import { VisitaGuiada } from '../../domain/entities/VisitaGuiada';
import { VisitaGuiadaRepository } from '../../domain/repositories/VisitaGuiadaRepository';
import { GOOGLE_SHEETS_CONFIG } from '../../shared/constants/GoogleSheetsConfig';
import { GoogleSheetsService, SpreadsheetData } from '../services/GoogleSheetsService';

export class GoogleSheetsVisitaGuiadaRepositoryImpl implements VisitaGuiadaRepository {
  private sheetsService: GoogleSheetsService;

  constructor() {
    this.sheetsService = new GoogleSheetsService(GOOGLE_SHEETS_CONFIG.SPREADSHEET_ID, '1095940623');
  }

  async findAll(): Promise<VisitaGuiada[]> {
    try {
      const spreadsheetData = await this.sheetsService.loadSpreadsheet();
      if (!spreadsheetData) return [];
      return this.parseSpreadsheetData(spreadsheetData);
    } catch {
      return [];
    }
  }

  async findUpcoming(): Promise<VisitaGuiada[]> {
    const all = await this.findAll();
    return all.filter(v => v.isUpcoming());
  }

  private parseSpreadsheetData(data: SpreadsheetData): VisitaGuiada[] {
    const visitas: VisitaGuiada[] = [];
    if (!data.table || !data.table.rows) return visitas;
    console.log('Total de linhas na planilha de visitas:', data.table.rows.length);
    for (let i = 0; i < data.table.rows.length; i++) {
      const row = data.table.rows[i];
      console.log(`Linha ${i}:`, row);
      if (!row.c || row.c.length < 2) continue;
      // Pular cabeçalho
      const firstCell = row.c[0]?.v?.toString() || '';
      if (i === 0 && (firstCell.toLowerCase() === 'data')) continue;
      try {
        const visita = this.parseRowToVisita(row, i);
        if (visita) {
          visitas.push(visita);
          console.log('Visita criada:', visita);
        } else {
          console.warn(`Linha ${i} não gerou visita válida`);
        }
      } catch (e) {
        console.error(`Erro ao processar linha ${i}:`, e);
      }
    }
    console.log('Total de visitas processadas:', visitas.length);
    return visitas;
  }

  private parseRowToVisita(row: { c: Array<{ v: string | number | null; f?: string }> }, rowNumber: number): VisitaGuiada | null {
    const cells = row.c;
    const dateCell = cells[0];
    const timeCell = cells[1];
    // const urlCell = cells[2]; // Removido
    if (!dateCell) return null;
    let visitaDate: Date;
    try {
      visitaDate = this.parseDateFlexible(dateCell);
    } catch {
      return null;
    }
    let timeStr = '09:00';
    if (timeCell) timeStr = this.parseTimeFlexible(timeCell);
    return new VisitaGuiada(
      { value: `visita-${rowNumber}` },
      { value: visitaDate },
      { value: timeStr }
    );
  }

  // Aceita datas como string dd/mm/yyyy, yyyy-mm-dd, ou número Google Sheets
  private parseDateFlexible(cell: { v: string | number | null; f?: string }): Date {
    if (cell.f && typeof cell.f === 'string') {
      // dd/mm/yyyy
      const parts = cell.f.split('/');
      if (parts.length === 3) {
        const [day, month, year] = parts;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }
      // fallback
      return new Date(cell.f);
    }
    if (typeof cell.v === 'number') return new Date(Math.round((cell.v - 25569) * 86400 * 1000));
    if (typeof cell.v === 'string') {
      // Tentar parsear Date(YYYY,MM,DD)
      const match = cell.v.match(/^Date\((\d{4}),(\d{1,2}),(\d{1,2})\)$/);
      if (match) {
        const [, year, month, day] = match;
        return new Date(Number(year), Number(month), Number(day));
      }
      // dd/mm/yyyy
      const parts = cell.v.split('/');
      if (parts.length === 3) {
        const [day, month, year] = parts;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }
      // yyyy-mm-dd
      if (/^\d{4}-\d{2}-\d{2}$/.test(cell.v)) return new Date(cell.v);
      // fallback
      return new Date(cell.v);
    }
    throw new Error('Data inválida');
  }

  // Aceita hora como string hh:mm:ss, hh:mm, ou número Google Sheets
  private parseTimeFlexible(cell: { v: string | number | null; f?: string }): string {
    if (cell.f) {
      // Se vier formatado, pode ser hh:mm:ss ou hh:mm
      const match = cell.f.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
      if (match) return `${match[1].padStart(2, '0')}:${match[2]}`;
      return cell.f;
    }
    if (typeof cell.v === 'number') {
      const totalMinutes = Math.round(cell.v * 24 * 60);
      const hours = Math.floor(totalMinutes / 60).toString().padStart(2, '0');
      const minutes = (totalMinutes % 60).toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    }
    if (typeof cell.v === 'string') {
      // hh:mm:ss ou hh:mm
      const match = cell.v.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
      if (match) return `${match[1].padStart(2, '0')}:${match[2]}`;
      return cell.v;
    }
    return '09:00';
  }
} 